import { styled } from "@mui/material/styles";
import { TextField } from "@mui/material";

export const StyledContainer = styled("div")(({ theme }) => ({
  overflow: "scroll",
  position: "fixed",
  top: 190,
  right: 110,
  bottom: 68,
  left: 290,
  paddingBottom: 10
}));

export const StyledHeader = styled("div")(({ theme }) => ({
  paddingLeft: "45%",
  width: "20%"
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  width: "100%"
}));
